module.exports = __webpack_public_path__ + "static/fcra-2016-17-q3-25193af8d923af0a8c98d12f2c53b95a.pdf";